import { InvestmentScenariiService } from './../../../@core/utils/investment-scenarii.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { KPI } from '../../../@core/api';
import { map } from 'rxjs/operators';
import { StyleService } from '../../../@core/utils';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NbSelectModule, NbOptionModule } from '@nebular/theme';

@Component({
    selector: 'app-scenarii-selector',
    templateUrl: './scenarii-selector.component.html',
    styleUrls: ['./scenarii-selector.component.scss'],
    standalone: true,
    imports: [NbSelectModule, FormsModule, NbOptionModule, AsyncPipe, TranslateModule]
})
export class ScenariiSelectorComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];

  public leftScenario: KPI.InvestmentScenario;
  public rightScenario: KPI.InvestmentScenario;

  public scenarii$: Observable<KPI.InvestmentScenario[][]> = combineLatest([
    this.investmentScenariiService.scenarii$,
    this.investmentScenariiService.selectedScenarii$
  ]);

  public leftScenarii$: Observable<KPI.InvestmentScenario[]> = this.scenarii$.pipe(
    map(([scenarii, [_leftScenario, rightScenario]]) =>
      // Don't show scenario selected on the other side
      scenarii.filter((scenario) =>
        !rightScenario || rightScenario.id !== scenario.id
      )
    ),
  );

  public rightScenarii$: Observable<KPI.InvestmentScenario[]> = this.scenarii$.pipe(
    map(([scenarii, [leftScenario, _rightScenario]]) =>
      // Don't show scenario selected on the other side
      scenarii.filter((scenario) =>
        !leftScenario || leftScenario.id !== scenario.id
      )
    ),
  );

  constructor(
    private investmentScenariiService: InvestmentScenariiService,
    public styleService: StyleService,
    private cdr: ChangeDetectorRef
  ) { }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.investmentScenariiService.getSelectedScenario('left').subscribe((scenario) => this.leftScenario = scenario),
      this.investmentScenariiService.getSelectedScenario('right').subscribe((scenario) => {
        this.rightScenario = scenario
        this.cdr.detectChanges();
      }),
    );
  }

  public selectScenario(side: KPI.LeftRight, scenarioId: number | null): void {
    this.investmentScenariiService.setSelectedScenario(scenarioId, side);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

}
